import { render } from "./theme31.vue?vue&type=template&id=bc7bf03e&scoped=true"
import script from "./theme31.vue?vue&type=script&lang=js"
export * from "./theme31.vue?vue&type=script&lang=js"

import "./theme31.vue?vue&type=style&index=0&id=bc7bf03e&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-bc7bf03e"

export default script